// Clickable marker component
AFRAME.registerComponent('marker', {
    schema: {
        icon: {type: 'string', default: 'icn_point'},
        label: {type: 'string', default: ''},
        labelWidth: {type: 'number', default: 1.6},
        enterColor: {type: 'string', default: '#ffffff'},
        leaveColor: {type: 'string', default: '#ffffff'},
        yRot: {type: 'number', default: 0},
        xRot: {type: 'number', default: 0},
        yPos: {type: 'number', default: 0},
        zPos: {type: 'number', default: -6}
    },
    init: function () {
        var data = this.data;
        var el = this.el;

        el.setAttribute('rotation', `0 ${data.yRot} 0`);
        el.setAttribute('position', `0 ${data.yPos} 0`);

        var xAxes = document.createElement("a-entity");
        xAxes.setAttribute('rotation', `${data.xRot} 0 0`);
        el.appendChild(xAxes);

        var marker = document.createElement("a-entity");
        marker.setAttribute('geometry', 'primitive: plane; width:0.5; height: 0.5;');
        marker.setAttribute('material', `shader: flat; transparent:true; opacity: 0.75; color: ${data.leaveColor}; src: #${data.icon}; `);
        marker.setAttribute('position', `0 0 ${data.zPos}`);
        marker.setAttribute('rotation', '0 0 0');
        marker.setAttribute('scale', '1 1 1');            
        marker.className = 'clk';
        xAxes.appendChild(marker);


        var ring = document.createElement("a-entity");
        ring.setAttribute('geometry', 'primitive: ring; radiusInner: 0.255; radiusOuter: 0.265;');
        ring.setAttribute('material', 'shader: flat; opacity: 0.75; color: white');
        ring.setAttribute('rotation', '0 0 0');
        ring.setAttribute('position', '0 0 -0.01');

        ring.setAttribute('animation__size', {
            property: 'geometry.radiusOuter',
            dir: 'alternate',
            dur: '750',
            loop: 'true',
            from: '0.265',
            to: '0.285'
        });
        ring.setAttribute('animation__opacity', {
            property: 'material.opacity',
            dir: 'alternate',
            dur: '750',
            loop: 'true',
            from: '0.75',
            to: '0.25'
        });

        marker.appendChild(ring);


        if(data.label != ''){
            var label = document.createElement("a-entity");
//            label.setAttribute('geometry','primitive: plane; width: 1.6; height: 0.5;');
            label.setAttribute('position', `0 0.7 ${data.zPos}`);
            label.setAttribute('visible', 'false');
            label.setAttribute('scale', '0.001 0.001 0.001');  
//            label.setAttribute('material', 'shader: flat; color: #fff;');

            label.setAttribute('slice9', `
                width: ${data.labelWidth}; 
                height: 0.5; 
                left: 20; 
                right: 43; 
                top: 20; 
                bottom: 43; 
                src: ./img/tooltip.png
            `);

            var labeltext = document.createElement("a-entity");
            labeltext.setAttribute('geometry',`primitive: plane; width: ${data.labelWidth-0.1}; height:0.4`);
            labeltext.setAttribute('material', 'shader:flat;');
            labeltext.setAttribute('position', `0 0 0.1`);
            labeltext.setAttribute('troika-text',`
                value: ${data.label}; 
                align: center;
                color: #000;
                fontSize: 0.18;
                depthOffset: -1;
                font:./fonts/PTSans-Bold.ttf;

                `);

            label.appendChild(labeltext);

            xAxes.appendChild(label);
            this.label = label;






        }

        marker.addEventListener('mouseenter', function(evt) {
            this.setAttribute('material', `color: ${data.enterColor}; opacity: 1;`);  
            this.setAttribute('scale', '1.1 1.1 1.1');  
            if(data.label != ''){
                label.setAttribute('visible','true');
                label.setAttribute('scale', '1 1 1');  
            }

            ring.setAttribute('animation__size', {
                property: 'geometry.radiusOuter',
                dir: 'normal',
                dur: '200',
                loop: 'false',
                to: '0.3'
            });
            ring.setAttribute('animation__opacity', {
                property: 'material.opacity',
                dir: 'normal',
                dur: '200',
                loop: 'false',
                to: '0.75'
            });




        });
        marker.addEventListener('mouseleave', function(evt) {
            this.setAttribute('material', `color: ${data.leaveColor}; opacity: 0.75;`);  
            this.setAttribute('scale', '1 1 1');  
            if(data.label != ''){
                label.setAttribute('visible','false');
                label.setAttribute('scale', '0.001 0.001 0.001');  
            }


            ring.setAttribute('animation__size', {
                property: 'geometry.radiusOuter',
                dir: 'alternate',
                dur: '750',
                loop: 'true',
                from: '0.265',
                to: '0.285'
            });
            ring.setAttribute('animation__opacity', {
                property: 'material.opacity',
                dir: 'alternate',
                dur: '750',
                loop: 'true',
                from: '0.75',
                to: '0.25'
            });



        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/marker.js
// module id = 7
// module chunks = 0